module.exports = __webpack_public_path__ + "img/nagano.66bdf424.png";